import { createSelector } from 'reselect';

const utilsState = state => state.utils;

export const getUtilsState = createSelector(
  [utilsState],
  utils => utils,
);

export const historySelector = history => {
  return history;
};
